function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicycle54(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.802 56.47 c -0.677 0 -1.313 -0.344 -1.684 -0.922 c -0.408 -0.636 -0.422 -1.448 -0.036 -2.099 l 12.68 -21.379 c 0.316 -0.533 0.86 -0.889 1.474 -0.965 l 27.594 -3.421 c 0.764 -0.093 1.506 0.254 1.923 0.895 c 0.417 0.642 0.432 1.465 0.037 2.121 L 46.579 52.683 c -0.323 0.539 -0.882 0.894 -1.507 0.959 L 18.01 56.459 C 17.94 56.466 17.871 56.47 17.802 56.47 z M 31.702 34.955 l -10.15 17.114 l 22.113 -2.302 L 54.246 32.16 L 31.702 34.955 z M 44.865 51.652 h 0.01 H 44.865 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.803 72.272 C 7.986 72.272 0 64.286 0 54.47 s 7.986 -17.802 17.803 -17.802 c 3.203 0 6.344 0.861 9.084 2.489 c 0.949 0.564 1.262 1.792 0.697 2.741 c -0.564 0.949 -1.79 1.262 -2.741 0.697 c -2.122 -1.261 -4.556 -1.928 -7.04 -1.928 C 10.192 40.667 4 46.859 4 54.47 c 0 7.611 6.192 13.803 13.803 13.803 c 7.61 0 13.802 -6.191 13.802 -13.803 c 0 -0.478 -0.024 -0.959 -0.073 -1.432 c -0.112 -1.099 0.687 -2.081 1.786 -2.193 c 1.101 -0.126 2.081 0.687 2.194 1.785 c 0.062 0.608 0.094 1.227 0.094 1.84 C 35.605 64.286 27.619 72.272 17.803 72.272 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.199 56.47 c -0.701 0 -1.382 -0.369 -1.748 -1.025 L 52.105 22.582 l -4.234 2.791 c -0.923 0.608 -2.163 0.353 -2.771 -0.569 c -0.608 -0.922 -0.353 -2.163 0.569 -2.771 l 6.032 -3.976 c 0.463 -0.306 1.031 -0.405 1.575 -0.273 c 0.54 0.132 1.001 0.482 1.271 0.968 l 19.395 34.743 c 0.539 0.964 0.193 2.183 -0.771 2.721 C 72.863 56.389 72.529 56.47 72.199 56.47 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.867 53.652 c -0.6 0 -1.192 -0.269 -1.586 -0.78 L 22.599 26.011 c -0.674 -0.875 -0.511 -2.131 0.364 -2.805 c 0.875 -0.674 2.132 -0.51 2.805 0.365 L 46.45 50.433 c 0.674 0.875 0.511 2.131 -0.365 2.805 C 45.722 53.517 45.292 53.652 44.867 53.652 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.567 26.791 H 17.803 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 12.765 c 1.104 0 2 0.896 2 2 S 31.672 26.791 30.567 26.791 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.197 72.272 c -9.816 0 -17.803 -7.986 -17.803 -17.803 s 7.986 -17.802 17.803 -17.802 S 90 44.653 90 54.47 S 82.014 72.272 72.197 72.272 z M 72.197 40.667 c -7.611 0 -13.803 6.192 -13.803 13.802 c 0 7.611 6.191 13.803 13.803 13.803 S 86 62.081 86 54.47 C 86 46.859 79.809 40.667 72.197 40.667 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle54);
export default __webpack_public_path__ + "static/media/bicycle-54.9e2a95417dc898821d8387493b87300d.svg";
export { ForwardRef as ReactComponent };